// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

export const WishlistModal = dynamic(() => import('./WishlistModal').then(mod => mod.WishlistModal));

export const WishlistModalConfig = {
  emptyLabel: 'wishlistModal',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/wishlistModal`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WishlistModalEditable = (props: any) => {
  return (
    <EditableComponent config={WishlistModalConfig} {...props}>
      <WishlistModal {...props} />
    </EditableComponent>
  );
};
